import { useReveal } from "../../hooks/useReveal";
import { GlassCard } from "../ui/GlassCard";

/**
 * "Was ist Jyotish?" — original synthesis (not copied) from: de.wikipedia.org/wiki/Jyotisha,
 * veda.ch/jyotish-die-vedische-astrologie, templeofdesire.de Jyotish-Guide,
 * ayurveda-journal.de/vedische-astrologie.
 */
export function WhatIsJyotish() {
  const scope = useReveal<HTMLElement>();
  return (
    <section id="was-ist-jyotish" ref={scope} className="relative py-24 md:py-32">
      <div className="container-lux">
        <div className="mx-auto max-w-2xl text-center">
          <p className="eyebrow mb-4" data-reveal>Grundlagen</p>
          <h2 className="text-3xl font-semibold md:text-5xl" data-reveal>
            Was ist Jyotish wirklich?
          </h2>
          <p className="mt-6 text-lg text-charcoal/70" data-reveal>
            Jyotish — sanskrit für „das Licht, das erkennen lässt" — ist keine
            Wahrsagerei, sondern eine jahrtausendealte Wissenschaft der
            Zeit. Sie liest die Position der Himmelskörper im Moment deiner
            Geburt als Landkarte deiner Seele: Anlage, nicht Urteil.
            Tendenz, nicht Zwang.
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-4xl gap-6 md:grid-cols-2">
          <GlassCard className="p-8" data-reveal>
            <h3 className="text-xl font-semibold text-slate-500">Westliche Astrologie</h3>
            <ul className="mt-4 space-y-3 text-sm text-charcoal/70">
              <li>Tropischer Tierkreis — orientiert an den Jahreszeiten.</li>
              <li>Die Sonne steht im Zentrum jeder Deutung.</li>
              <li>12 grobe Zeichen, kein systematisches Zeit-Timing.</li>
            </ul>
          </GlassCard>
          <GlassCard className="p-8 border-gold/40" data-reveal>
            <h3 className="text-xl font-semibold text-gold-deep">Jyotish (Vedisch)</h3>
            <ul className="mt-4 space-y-3 text-charcoal/80">
              <li className="flex items-start gap-2"><span className="mt-1 text-gold">✦</span><span><strong>Siderischer Zodiak</strong> — ausgerichtet an den realen Fixsternen; der Aszendent heißt hier <strong>Lagna</strong>.</span></li>
              <li className="flex items-start gap-2"><span className="mt-1 text-gold">✦</span>Der Mond steht im Zentrum: Gefühl, Instinkt, innere Natur.</li>
              <li className="flex items-start gap-2"><span className="mt-1 text-gold">✦</span><span>27 <strong>Nakshatras</strong> plus <strong>Vimshottari Dasha</strong> für präzises Timing.</span></li>
            </ul>
          </GlassCard>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center text-sm text-charcoal/50" data-reveal>
          Der Unterschied zwischen beiden Systemen beträgt heute rund 24° —
          die sogenannte Ayanamsa (Standard: <strong>Lahiri Ayanamsha</strong>),
          die sich durch die langsame Präzession der Erdachse über Jahrtausende
          aufgebaut hat. Deshalb tragen viele Menschen im vedischen System ein
          anderes Zeichen als im westlichen.
        </p>
      </div>
    </section>
  );
}
